{
  "messages": {
    "maximumInSizeOnlyOneImageTextZipOrSpreadsheetAllowedToUploadMultipleDocsZipFirstThenUpload": "Máximo {size} em tamanho. Apenas {imageLimit}, {typeLimitText}, {typeLimitZip} ou {typeLimitSpreadsheet} permitido. Para carregar vários documentos, compacte primeiro e depois carregue.",
    "maximumInSizePerFileOnlyImageTextZipSpreadsheetAllowed": "Máximo {size} em tamanho por arquivo. Máximo {count} arquivos. Apenas {image}, {text}, {zip} ou {spreadsheet} permitido.",
    "oneImage": "UMA imagem",
    "sizeInMegabytes": "{size} MB",
    "uploadDocument": "Carregar documento",
    "uploadDocuments": "Carregar documentos"
  }
}
